import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpService } from './http.service';

export interface WelcomeVideoConfig {
  videoUrl: string;
}

@Injectable({ providedIn: 'root' })
export class ConfigService {
  constructor(private http: HttpService) {}

  getWelcomeVideoUrl(): Observable<string> {
    return this.http
      .getWithoutAuth<{ success: boolean; data: WelcomeVideoConfig }>('SystemConfig/welcome-video')
      .pipe(map(res => res.data.videoUrl));
  }
}
